module.exports = __webpack_public_path__ + "img/3.509341b1.png";